/* PRD-037 — Hook compartido: carga los comercios del partner (lista enriquecida). */
import { useCallback, useEffect, useState } from 'react';
import { listPartnerCommerces, type PartnerCommerce } from '@services/partnerService';
import { usePartnerAuth } from './PartnerAuthContext';

export const useCommerces = () => {
  const { token } = usePartnerAuth();
  const [commerces, setCommerces] = useState<PartnerCommerce[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    setError(null);
    try {
      setCommerces(await listPartnerCommerces(token));
    } catch {
      setError('No se pudieron cargar los comercios.');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { commerces, loading, error, refresh };
};

export const fmtDate = (s: string | null) => {
  if (!s) return '';
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
};
